module.exports = __webpack_public_path__ + "img/goods16_2.1a5ebd16.jpg";